import saveFrequentlyUsedFolders from '../services/saveFrequentlyUsedFolders';
import { getStore } from '../store/store';
import { action } from 'satcheljs/lib/legacy';
var MAX_FOLDER_LIST_SIZE = 10;
var FOLDER_INCREMENT = 5;
var MAX_FOLDER_WEIGHT = 20;
var MILLISECONDS_IN_WEEK = 7 * 86400000;
// sort folders by weight
var sortFolders = action('sortFolders')(function sortFolders() {
    var store = getStore();
    var sortedList = store.frequentlyUsedFolders.sort(function (folder1, folder2) {
        if (folder1.Weight == folder2.Weight) {
            return Math.abs(Date.parse(folder2.lvt) - Date.parse(folder1.lvt));
        }
        return folder2.Weight - folder1.Weight;
    });
    store.frequentlyUsedFolders = sortedList;
});
// add folder to frequently used folder list
export default action('addFrequentlyUsedFolder')(function addFrequentlyUsedFolder(folderId) {
    var foundFolder = false;
    var store = getStore();
    if (!store.isInitialized) {
        return;
    }
    // If a folder is found in frequently used folder list, increment its weight and decrement weight of remaining folders
    for (var i = store.frequentlyUsedFolders.length - 1; i >= 0; i--) {
        var folder = store.frequentlyUsedFolders[i];
        if (folder.FolderId == folderId) {
            folder.Weight += FOLDER_INCREMENT;
            folder.Weight = Math.min(folder.Weight, MAX_FOLDER_WEIGHT);
            folder.lvt = new Date().toISOString();
            foundFolder = true;
        }
        else {
            folder.Weight--;
            folder.Weight = Math.max(folder.Weight, 0);
            if (folder.Weight <= 0) {
                // Handle isNaN case for lastVisitedTime
                var timeSinceFolderVisited = Math.abs(Date.now() - Date.parse(folder.lvt));
                var visitedWithinTimePeriod = timeSinceFolderVisited < MILLISECONDS_IN_WEEK && timeSinceFolderVisited >= 0;
                if (!visitedWithinTimePeriod) {
                    store.frequentlyUsedFolders.splice(i, 1);
                }
            }
        }
    }
    // Add folder to the list if it was not found
    if (!foundFolder) {
        store.frequentlyUsedFolders.push({
            FolderId: folderId,
            Weight: MAX_FOLDER_LIST_SIZE,
            lvt: new Date().toISOString(),
        });
    }
    // Sort folder list
    sortFolders();
    // Trim folder list to keep max items
    store.frequentlyUsedFolders.splice(MAX_FOLDER_LIST_SIZE);
    // save user options
    saveFrequentlyUsedFolders();
});
//# sourceMappingURL=addFrequentlyUsedFolder.js.map